import _ from 'lodash'
import nullifyNotSet from './nullifyNotSet'

export default ({ reorderMutationName, reorder, items }) => ({
  draggableId: id,
  destination: {
    index,
    droppableId: siteId,
  },
  destination,
  ...rest
}) => (
  reorder({
    variables: {
      id,
      data: {
        index,
        siteId: nullifyNotSet(siteId),
      },
    },
    optimisticResponse: {
      __typename: 'Mutation',
      [reorderMutationName]: {
        ..._.find(items, { id }),
        siteId: nullifyNotSet(siteId),
        index,
      },
    },
  })
)
